import { ResponseTransform } from "utils";
import api from "api";

export const getMonitorinTrips = async (idProject, startDate, endDate,idOperator) => {
  let queryParameters = '';
  if(idOperator) {
    queryParameters += `idOperator=${idOperator}&`
  }
  if(startDate) {
    queryParameters += `dateInit=${startDate}&`
  }
  if(endDate) {
    queryParameters += `dateEnd=${endDate}`
  }
  let endPoint = `/api/trip/historyByProject/${idProject}?${queryParameters}`;
  const response = await api.get(endPoint).then(ResponseTransform);
  return response;
};

export const getStatus = async () => {
  const endPoint = `/api/trip/status-trips`;
  const response = await api.get(endPoint).then(ResponseTransform);
  return response;
};

export const getCarrier = async (idCarrier) => {
  const endPoint = `/api/carrier/${idCarrier}`;
  const response = await api.get(endPoint).then(ResponseTransform);
  return response;
};

export const getStage = async (idTrip) => {
  const endPoint = `/api/trip/itinerary/${idTrip}`;
  const response = await api.get(endPoint).then(ResponseTransform);
  return response;
};

export const getAnswers = async (idResponseStage) => {
  const endPoint = `/api/stage/${idResponseStage}/answers`;
  const responseApi = await api.get(endPoint).then(ResponseTransform);
  return responseApi;
};

export const getTripWithRoute = async (idTrip) => {
  const endPoint = `/api/trip/get-trip-with-route/${idTrip}`;
  let responseApi = await api.get(endPoint).then(ResponseTransform);
  return responseApi;
};

export const getBodyAlert = async (idTrip) => {
  const endPoint = `/api/trip/${idTrip}/body-trip-alert`;
  const responseApi = await api.get(endPoint).then(ResponseTransform);
  return responseApi;
};

//get Operator inut select
export const getOperatorWithTrip = async (idProject) => {
  const endPoint = `/api/project/${idProject}/operators-with-trip`;
  const response = await api.get(endPoint).then(ResponseTransform);
  return response;
};

export const getDestinationsTrip = async (idTrip) => {
  const endPoint = `/api/trip/${idTrip}/destinations`;
  const response = await api.get(endPoint).then(ResponseTransform);
  return response;
};

export const getDestailsTrip = async (idTripDetail) => {
  const endPoint = `/api/stage/trip-detail/${idTripDetail}`;
  const response = await api.get(endPoint).then(ResponseTransform);
  return response;
};

export const getRoutesByTrip = async (id) => {
  const endPoint = `/api/trip/${id}/route`;
  const response = await api.get(endPoint).then(ResponseTransform);
  return response;
};

export const getHistory = async (idProject, params) => {
  const endPoint = `/api/trip/historyByProject/${idProject}${params}`;
  const response = await api.get(endPoint).then(ResponseTransform);
  return response;
};

export const getAppointmentReport = async (params="") => {
  const endPoint = `/api/trip/trip-details-report${params}`;
  const response = await api.get(endPoint).then(ResponseTransform);
  return response;
};

export const getOperators = async (idProject) => {
  const endPoint = `api/project/${idProject}/operators`;
  const response = await api.get(endPoint).then(ResponseTransform);
  return response;
};

export const getCostReport = async (params="") => {
  const endPoint = `api/cost-report?${params}`;
  const response = await api.get(endPoint).then(ResponseTransform);
  return response;
};
